import { Text, VStack } from "@chakra-ui/react"

const CQError = () => {
    return <VStack justifyContent={'center'} h={'100%'} textAlign={'center'} minHeight={150}>
        <Text>There is no data to display.</Text>
    </VStack>

}
export default CQError